const { createSlice, createAsyncThunk, createDraftSafeSelector } = require("@reduxjs/toolkit");
import Axios from "axios";
import { mergeObject } from "src/utils";
import { FS } from "../other/constance";

const client = Axios.create({
  baseURL: "https://backend-nft-app.trava.finance",
});

// action thunks

// prettier-ignore
export const fetchKnightData = createAsyncThunk(
  "knightSlice/fetchKnightData",
  async (_, thunkAPI) => {
    await Promise.all([
      thunkAPI.dispatch(fetchCollectionMeta()),
      thunkAPI.dispatch(fetchKnightRegistry({ page: 1 })),
    ]);
  }
);

export const fetchCollectionMeta = createAsyncThunk("knightSlice/fetchCollectionMeta", async () => {
  const res = await client.get("/v1/collections/meta").then((res) => res.data);
  return res;
});

export const fetchKnightRegistry = createAsyncThunk("knightSlice/fetchKnightRegistry", async (params) => {
  const { page, limit = 5, expMin, expMax, search, rarity, sort = "-exp" } = params;
  const res = await client
    .get("/v1/collections", {
      params: {
        page,
        limit,
        expmin: expMin,
        expmax: expMax,
        search,
        rarity,
        sort,
      },
    })
    .then((res) => res.data);
  return res;
});

const initialState = {
  fetchKnightDataStatus: FS.INITIAL,
  knightStatistic: undefined,
  topAddresses: undefined,
  knightRegistry: undefined,
  knightRegistryConfig: {
    page: 1,
    rowsPerPage: 5,
    order: "desc",
    orderBy: "exp",
    expMax: undefined,
    expMin: undefined,
    rarities: [],
    owner: undefined,
  },
};

const knightSlice = createSlice({
  name: "knightSlice",
  initialState: initialState,
  reducers: {
    searchTermChange: (state, action) => {
      state.searchTerm = action.payload;
    },
    filterChange: (state, action) => {
      state.filter = action.payload;
    },
    updateKnightRegistryConfig: (state, action) => {
      state.knightRegistryConfig = mergeObject(state.knightRegistryConfig, action.payload);
    },
  },
  extraReducers: {
    [fetchKnightData.pending](state, _) {
      state.fetchKnightDataStatus = FS.FETCHING;
    },
    [fetchKnightData.fulfilled](state, _) {
      if (state.fetchKnightDataStatus !== FS.FAIL) {
        state.fetchKnightDataStatus = FS.SUCCESS;
      }
    },

    // fetch collection metadata
    [fetchCollectionMeta.fulfilled](state, action) {
      state.knightStatistic = {
        rarities: {
          copper: action.payload.totalRarity1,
          silver: action.payload.totalRarity2,
          gold: action.payload.totalRarity3,
          diamond: action.payload.totalRarity4,
          crystal: action.payload.totalRarity5,
          limited: action.payload.totalRarity6,
        },
        totalNFT: action.payload.totalNFT,
        totalBurnedNFT: action.payload.totalBurnedNFT,
      };
      state.topAddresses = action.payload.topAddresses.sort((i1, i2) => parseInt(i2.count) - parseInt(i1.count));
    },
    [fetchCollectionMeta.rejected](state, _) {
      state.fetchKnightDataStatus = FS.FAIL;
      state.knightStatistic = undefined;
      state.topAddresses = undefined;
    },

    // fetch registry
    [fetchKnightRegistry.fulfilled](state, action) {
      state.knightRegistry = {
        totalPages: action.payload.totalPages,
        totalKnights: action.payload.totalDocs,
        list: action.payload.docs,
      };
    },
    [fetchKnightRegistry.rejected](state, _) {
      state.fetchKnightDataStatus = FS.FAIL;
      state.knightRegistry = undefined;
    },
  },
});

export default knightSlice.reducer;
export const {
  trakCountChange,
  trakPercentageChange,
  totalNFTChange,
  searchTermChange,
  filterChange,
  updateKnightRegistryConfig,
} = knightSlice.actions;

// selectors
export const selectKnightSlice = (state) => state.knightSlice;

export const selectKnightStatistic = createDraftSafeSelector(
  (state) => selectKnightSlice(state).knightStatistic,
  (knightStatistic) => {
    if (!knightStatistic) return null;
    const trakCount = Object.entries(knightStatistic.rarities).map((item) => item[1]);
    const trakPercentage = trakCount.map((item) => (item / knightStatistic.totalNFT) * 100);
    return { trakCount, trakPercentage };
  }
);

// prettier-ignore
export const selectTotalKnights = createDraftSafeSelector(
  selectKnightSlice,
  (knightSlice) => {
  return knightSlice.knightStatistic?.totalNFT;
});

// prettier-ignore
export const selectTopCommanders = createDraftSafeSelector(
  selectKnightSlice,
  (knightSlice) => {
    if (!knightSlice.topAddresses) return null;
    return knightSlice.topAddresses.slice(0, 3);
  }
);
